import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import DataTableCell from './components/dataTableCell';

const SearchResultsModalTable = styled.table`
    table-layout:fixed;

    tr:first-child {
        border-top:none; 
    }

`;

class SearchResultsModalContent extends React.Component {

    constructor(props) {
        super(props);
        
        this.state = {
            dataTableRowArray: []
        }
    }

    
    componentDidMount() {
        let dataTableRowArray = this.state.dataTableRowArray;
        Object.keys(this.props.dataTableRow).forEach((key, value) => {
            console.log(key);
            if (key !== 'FILE_DATA' && key !== 'FILE_FULLNAME' && key !== 'MODIFIED_BY' && key !== 'MODIFIED' && key !== '@search.score') {
                dataTableRowArray.push(<DataTableCell key={key} cellTitle={key} cellValue={this.props.dataTableRow[key]} />)
            }
        })

        this.setState({dataTableRowArray: dataTableRowArray});

    }

    render() {

        return(
            <React.Fragment>
                <div className="table-responsive">
                    <SearchResultsModalTable>
                        <tbody>
                            {this.state.dataTableRowArray.map(item => {
                                return item;
                            })}
                        </tbody>                    
                    </SearchResultsModalTable>
                </div>
            </React.Fragment>
        )
    }
}

SearchResultsModalContent.propTypes = {
    dataTableRow: PropTypes.object,
}

export default SearchResultsModalContent;


// WEBPACK FOOTER //
// ./src/components/searchResults/components/searchResultsModalContent/searchResultsModalContent.js